<template>
  <div>
    <MenuBar />
    <section>
      <InfoPanel />
    </section>
  </div>
</template>

<script>
  import MenuBar from "@/views/_globals/MenuBar.vue"
  import InfoPanel from '@/components/shared/InfoPanel'

  export default {
    name: 'Info',
    components: {
      MenuBar,
      InfoPanel
    },
  }
</script>
